import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const CarouselContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    width: '99vw',
    margin: '0',
    borderRadius: '24px',
    overflow: 'hidden',
    paddingTop: '20%',
    left: '50%',
    right: '50%',
    marginLeft: '-49.5vw',
    marginRight: '-49.5vw',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',

    [theme.breakpoints.down('lg')]: {
        paddingTop: '17%',
        borderRadius: '20px',
    },
    [theme.breakpoints.down('md')]: {
        paddingTop: '13%',
        borderRadius: '16px',
    },
    [theme.breakpoints.down('sm')]: {
        paddingTop: '10%',
        borderRadius: '12px',
    },
}));

export const Slide = styled(Box)(({ active }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: active ? 1 : 0,
    transition: 'opacity 0.8s ease-in-out',
    borderRadius: 'inherit',
    overflow: 'hidden',
    // Ensure only the visible slide can receive clicks
    pointerEvents: active ? 'auto' : 'none',
    zIndex: active ? 2 : 1,
}));

export const SlideImage = styled('img')(({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 'inherit',
    [theme.breakpoints.down('md')]: {
        objectPosition: 'center',
    },
    [theme.breakpoints.down('sm')]: {
        objectFit: 'cover',
        objectPosition: 'center center',
    },
}));

export const DotsWrapper = styled(Box)(({ theme }) => ({
    width: '100%',
    marginTop: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',

    [theme.breakpoints.down('md')]: {
        gap: '8px',
        marginTop: '10px',
    },
    [theme.breakpoints.down('sm')]: {
        gap: '6px',
        marginTop: '8px',
    },
}));

export const Dot = styled('div')(({ active, theme }) => ({
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: active ? '#002F87' : '#fff',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease, transform 0.3s ease',
    '&:hover': { backgroundColor: '#FF4B2B', transform: 'scale(1.2)' },

    [theme.breakpoints.down('md')]: {
        width: '8px',
        height: '8px',
    },
    [theme.breakpoints.down('sm')]: {
        width: '6px',
        height: '6px',
    },
}));

export const ArrowButtonLeft = styled(Box)(({ theme }) => ({
    position: 'absolute',
    left: '20px',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 3,
    cursor: 'pointer',
    borderRadius: '50%',
    padding: '10px',
    transition: 'background-color 0.3s ease',

    [theme.breakpoints.down('md')]: {
        left: '10px',
        padding: '8px',
    },
    [theme.breakpoints.down('sm')]: {
        left: '6px',
        padding: '6px',
    },
}));

export const ArrowButtonRight = styled(Box)(({ theme }) => ({
    position: 'absolute',
    right: '20px',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 3,
    cursor: 'pointer',
    borderRadius: '50%',
    padding: '10px',
    transition: 'background-color 0.3s ease',

    [theme.breakpoints.down('md')]: {
        right: '10px',
        padding: '8px',
    },
    [theme.breakpoints.down('sm')]: {
        right: '6px',
        padding: '6px',
    },
}));
